<template>
   <div class="footer-dark">
        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-3 item">
                        <h3>Products</h3>
                        <ul>

                            <li><a href="#"> Email API</a></li>
                            <li><a href="#">Inbound Email Routing</a></li>
                            <li><a href="#">Send Time Optimization</a></li>
                            <li><a href="#">Email Analytics</a></li>
                            <li><a href="#">Email Logs</a></li>
                            <li><a href="#">Email Verification</a></li>
                            
                        </ul>
                    </div>
                    <div class="col-md-3 item">
                        <h3>Solutions</h3>
                        <ul>
                           
                            <li><a href="#"> Transactional Emails</a></li>
                            <li><a href="#">Email Parsing</a></li>
                            <li><a href="#">Email Sending</a></li>
                            <li><a href="#">White Labeling</a></li>
                            <li><a href="#">Receiving Email</a></li>
                            <li><a href="#">Burst Sending</a></li>
                            
                        </ul>
                    </div>
                    <div class="col-md-3 item">
                        <h3>Enterprice</h3>
                        <ul>
                        <li><a href="#"> Enterprise</a></li>
                        <li><a href="#">Consulting</a></li>
                        <li><a href="#">Consulting</a></li> 
                        <li><a href="#">SAML Authentication</a></li>
                        <li><a href="#">Schedule a demo</a></li>

                        </ul>
                    </div>
                    <div class="col-md-3 item text">
                        <h3>webITSecure</h3>
                        <p style="color:black">Expert insights, industry trends, and inspiring stories that help you live and work on your own terms.</p>
                    </div>
                    
                    <div class="col item social mt-3">
                        <a href="#"><i class="fa fa-facebook"></i></a>
                        <a href="#"><i class="fa fa-twitter"></i></a>
                        <a href="#"><i class="fa fa-snapchat"></i></a>
                        <a href="#"><i class="fa fa-instagram"></i></a>
                    </div>
                </div>
                <p class="copyright">WebITSecure © 2022</p>
            </div>
        </footer>
   </div>
</template>
<script>
export default {
    name:'Footer',
    data:()=>({ 

    })
}
</script>
<style lang="css" scoped>
@import "https://fonts.googleapis.com/css?family=Poppins:400,500,700&display=swap";
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&family=Raleway&family=Roboto:wght@500&display=swap');
.footer-dark {
    padding:100px 0px;
    color: #0085A1;
    background-color:#f4f7fae3;
  }
  
  .footer-dark h3 {
    margin-top:0;
    margin-bottom:12px;
    font-weight:bold;
    font-size:16px;
    font-family: 'Poppins';
  }
  
  .footer-dark ul {
    padding:0;
    list-style:none;
    line-height:1.8;
    font-size:14px;
    margin-bottom:0;
  }
  
  .footer-dark ul a {
    color:inherit;
    text-decoration:none;
    opacity:0.6;
    font-family: 'Roboto';
  }
  
  .footer-dark ul a:hover {
    opacity:0.8;
  }
  
  @media (max-width:767px) {
    .footer-dark .item:not(.social) {
      text-align:center;
      padding-bottom:20px;
    }
  }
  
  .footer-dark .item.text {
    margin-bottom:36px;
  }
  
  @media (max-width:767px) {
    .footer-dark .item.text {
      margin-bottom:0;
    }
  }
  
  .footer-dark .item.text p {
    opacity:0.6;
    font-family: Roboto;
    /* font-family: Montserrat-regular; */
    margin-bottom:0;
    font-size: 14px;
  }
  
  .footer-dark .item.social {
    text-align:center;
  }
  
  @media (max-width:991px) {
    .footer-dark .item.social {
      text-align:center;
      margin-top:20px;
    }
  }
  
  .footer-dark .item.social > a {
    font-size:20px;
    width:36px;
    height:36px;
    line-height:46px;
    display:inline-block;
    text-align:center;
    border-radius:50%;
    box-shadow:#0085A1;
    margin:0 8px;
    color:#0085A1;
    opacity:0.75;
  }
  
  .footer-dark .item.social > a:hover {
    opacity:0.9;
  }
  
  .footer-dark .copyright {
    text-align:center;
    padding-top:24px;
    opacity:0.3;
    font-size:13px;
    margin-bottom:0;
  }
  
  
</style>